import dashboardService from './dashboardService'

export default dashboardService
